export default "__VITE_ASSET__iJMuW1_Q__"